import { reactive } from '@vue/composition-api';
import riverWaterLevelObservatoryApi from '@/apis/river_water_level_observatories';
import { RiverWaterLevelObservatoryExt } from '@/models';
import {
  UseRiverWaterLevelObservatoryParams,
  UseRiverWaterLevelObservatoryResult,
  UseRiverWaterLevelObservatoryState,
} from '@/models/useRiverWaterLevelObservatory';
import { getInitUseRiverWaterLevelObservatoryState } from '@/composables/utils';

export function useRiverWaterLevelObservatory(
  params: UseRiverWaterLevelObservatoryParams,
): UseRiverWaterLevelObservatoryResult {
  const state = reactive<UseRiverWaterLevelObservatoryState>(getInitUseRiverWaterLevelObservatoryState());

  const onClickRiverWaterLevelObservatory = (riverWaterLevelObservatory: RiverWaterLevelObservatoryExt): void => {
    params.deselectLayers({ excludes: ['riverWaterLevelObservatories'] });
    if (!params.refExtremeMap.value) return;

    if (riverWaterLevelObservatory.isSelected) {
      params.refExtremeMap.value.showRiverWaterLevelObservatoryPopup(riverWaterLevelObservatory);
    } else {
      params.refExtremeMap.value.hidePopup();
    }
  };

  const toggleRiverWaterLevelObservatoryLayer = async(): Promise<void> => {
    if (!params.refExtremeMap.value) return;

    const currentDataMap = params.refExtremeMap.value.getRiverWaterLevelObservatoryMap();
    const currentSelectedObservatory = Object.values(currentDataMap).find(
      riverWaterLevelObservatory => riverWaterLevelObservatory.isSelected,
    );

    if (state.showRiverWaterLevelObservatory) {
      params.state.showWaitSpinner = true;

      if (!state.riverWaterLevelObservatoryAreaFilter.length) {
        if (currentSelectedObservatory) {
          params.refExtremeMap.value.hidePopup();
        }
        params.refExtremeMap.value.showRiverWaterLevelObservatoryLayer([]);
        params.state.showWaitSpinner = false;
        return;
      }

      const reqParams = { areas: state.riverWaterLevelObservatoryAreaFilter };
      const { data: observatories } = await riverWaterLevelObservatoryApi.getObservatories(reqParams);

      const observatoriesExt = observatories.map(observatory => {
        return {
          ...observatory,
          isSelected: false,
        };
      });

      params.state.showWaitSpinner = false;

      observatoriesExt.forEach(observatory => {
        const current = currentDataMap[observatory.id];
        observatory.isSelected = current ? current.isSelected : false;
      });
      if (currentSelectedObservatory) {
        const stillExists = observatoriesExt.find(observatory => observatory.id === currentSelectedObservatory.id);
        if (!stillExists) {
          params.refExtremeMap.value.hidePopup();
        }
      }
      params.refExtremeMap.value.showRiverWaterLevelObservatoryLayer(observatoriesExt);
    } else {
      if (currentSelectedObservatory) {
        params.refExtremeMap.value.hidePopup();
      }
      params.refExtremeMap.value.removeRiverWaterLevelObservatoryLayer();
    }
  };

  const deselectAllRiverWaterLevelObservatory = (): void => {
    if (!params.refExtremeMap.value) return;

    params.refExtremeMap.value.deselectAllRiverWaterLevelObservatory();
  };

  return {
    state,
    onClickRiverWaterLevelObservatory,
    toggleRiverWaterLevelObservatoryLayer,
    deselectAllRiverWaterLevelObservatory,
  };
}
